import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface WorkflowChainProps {
  steps: string[];
  /** How many steps have been revealed so far. */
  revealed: number;
}

/** The attachment moving through the digital workflow, as one quiet line of chips. */
export function WorkflowChain({
  steps,
  revealed
}: WorkflowChainProps) {
  return <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-2" data-id="element-169" data-mp="32s6yugma68k3">
      {steps.map((step, index) => {
      const isVisible = revealed > index;
      const isLast = index === steps.length - 1;
      return <li key={step} className="flex items-center gap-1.5" data-id="element-170" data-mp="3bsc7eu37nczu" data-mpi={index}>
            <span className={`rounded-full border px-3 py-1.5 font-headline text-[11px] font-bold tracking-[0.04em] transition-[opacity,transform,border-color,color] duration-300 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'} ${isLast ? 'border-solventum-primary/50 text-solventum-primary' : 'border-white/15 text-white/80'}`} data-id="element-171" data-mp="3qhrmhctdptzp">
              {step}
            </span>
            {!isLast && <ChevronRightIcon className={`h-3 w-3 text-solventum-primary/60 transition-opacity duration-300 ease-out ${revealed > index + 1 ? 'opacity-100' : 'opacity-0'}`} aria-hidden="true" data-id="element-172" data-mp="2p0avqio64efn" />}
          </li>;
    })}
    </ol>;
}